import { CommonModule } from "@angular/common"
import { Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy, ElementRef, NgZone, Renderer2 } from "@angular/core"

@Component({
	selector: "app-header",
	standalone: true,
	imports: [CommonModule],
	templateUrl: "./header.component.html",
	styleUrl: "./header.component.scss",
})
export class HeaderComponent {

}

